import { formatPrice, type FractionDigits } from '../currency';
import { StrikePrice } from './StrikePrice';

export interface PromoPriceProps {
  /** What the player pays; null is a figure that is not quoted yet. */
  amount: number | null;
  /** The regular price the promotion replaced — struck through next to
   *  `amount`, and only when it is higher than what the player pays. */
  original?: number | null | undefined;
  decimals?: FractionDigits;
}

const cents = (value: number) => Math.round(value * 100);

/**
 * A price with its regular price struck through in front of it. Without a
 * regular price (or one that is not higher) it is exactly the plain amount —
 * the same text node the row showed before promotions existed — so a delivery
 * no promotion priced looks the same as ever.
 */
export function PromoPrice({ amount, original, decimals = 2 }: PromoPriceProps) {
  if (amount === null) return <>—</>;

  const paid = formatPrice(amount, decimals);
  if (original == null || cents(original) <= cents(amount)) return <>{paid}</>;

  return (
    <>
      <StrikePrice amount={original} decimals={decimals} className="mr-1.5" />
      {paid}
    </>
  );
}
